var map = {
	"./menu-approval.svg": "98ad",
	"./menu-audit-form.svg": "323d",
	"./menu-audit.svg": "8c3e",
	"./menu-basic.svg": "2755",
	"./menu-commission.svg": "6ed6",
	"./menu-company.svg": "5e61",
	"./menu-ditu.svg": "fd55",
	"./menu-feiyong.svg": "a3e8",
	"./menu-form.svg": "0fa3",
	"./menu-guihuatu.svg": "e6e0",
	"./menu-home.svg": "320b",
	"./menu-kaohe.svg": "037a",
	"./menu-notice.svg": "61ef",
	"./menu-pingjia.svg": "c699",
	"./menu-proItem.svg": "6a7f",
	"./menu-project.svg": "34b9",
	"./menu-site.svg": "c511",
	"./menu-sjtj.svg": "85b8",
	"./menu-system.svg": "5a1d",
	"./menu-task.svg": "a05b",
	"./menu-xianqu.svg": "fa08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a9d";